import register from '../register';

let $banner      = document.querySelector('.urgency-banner');
let $body        = document.body;
let $hours       = document.querySelector('.hours');
let $minutes     = document.querySelector('.minutes');
let $day         = document.querySelector('.day');
let $hoursPlural = document.querySelector('.hours__plural');
let $minPlural   = document.querySelector('.minutes__plural');

let tracked = false;

let config = {
  startHour: 0,
  endHour: 15
};

function getCurrentTime() {
  let now   = new Date();
  let year  = now.getFullYear();
  let month = now.getMonth();
  let date  = now.getDate();
  let day   = now.getDay();
  let hour  = now.getHours();
  let min   = now.getMinutes();

  return { year, month, date, day, hour, min };
}

function getTimeRemaining( endTime ) {
  let t = endTime - Date.now();
  let hours = Math.floor( ( t / ( 1000 * 60 * 60 ) ) % 24 );
  let minutes = Math.floor( ( t / 1000 / 60 ) % 60 );
  let seconds = Math.floor( ( t / 1000 ) % 60 );

  return { hours, minutes, seconds };
}

function checkTime() {
  let t = getCurrentTime();

  // if Sat or Sun
  if ( t.day === 6 || t.day === 0 ) {
    return false;
  }

  // if Fri after 3p
  if ( t.day === 5 && t.hour >= config.endHour ) {
    return false;
  }

  // if between 12am and 3pm
  if ( t.hour >= config.startHour && t.hour < config.endHour ) {
    let endTime = new Date( t.year, t.month, t.date, config.endHour, 0 );
    return {
      time: getTimeRemaining( endTime ),
      day: 'Today',
      experience: 'sameday'
    };
  }

  // if between 3:01p and midnight
  if ( t.hour >= config.endHour ) {
    let endTime = new Date( t.year, t.month, t.date, config.endHour, 0 );
    let tomorrow = endTime.setDate( endTime.getDate() + 1 );
    return {
      time: getTimeRemaining( tomorrow ),
      day: 'Tomorrow',
      experience: 'nextday'
    };
  }

  return false;
}

function updateClock( res ) {
  $hours.innerText = res.time.hours;
  $minutes.innerText = res.time.minutes;
  $day.innerText = res.day;
  $hoursPlural.innerText = res.time.hours === 1 ? '' : 's';
  $minPlural.innerText = res.time.minutes === 1 ? '' : 's';
}

function loop() {
  setTimeout( loop, 1000 );
  let t = checkTime();

  if ( t ) {
    showBanner();
    if ( !tracked ) {
      acumen.track( 'web-track-urgency_banner', { experience: t.experience } );
      tracked = true;
    }
    updateClock( t );
    return;
  }

  hideBanner();

  if ( !tracked ) {
    acumen.track( 'web-track-urgency_banner', { experience: 'nobanner' } );
    tracked = true;
  }
}

function init() {
  loop();
}

function hideBanner() {
  $banner.style.display = 'none';
  $body.classList.remove('has-urgency-banner');
}

function showBanner() {
  $banner.style.display = 'block';
  $body.classList.add('has-urgency-banner');
}

register( 'urgency-banner', init );

export default undefined;
